import { styles as commonStyles } from '../styles/common.scss';
import { styles as styleHelpersStyles } from '../../../../assets/style-helpers.scss';

export const reuseCheckbox = `
  <style>${styleHelpersStyles}</style>
  <gz-form-field class="sensor-reuse-wrapper mb-2">
    <gz-checkbox gz-form-input class="sensor-reuse" checked></gz-checkbox>
  </gz-form-field>
`;

export const templateSensor = `
  <style>${styleHelpersStyles}</style>
  <style>${commonStyles}</style>
  <div class="form-wrapper" id="integration-types" class="sensor-wrapper">
          <gz-form-field  class="sensor-select-wrapper mb-2">
               <gz-checkbox gz-form-input class="sensor-select" checked></gz-checkbox>
          </gz-form-field>
          {sensorDataReuse}
          <div class="sensor-data">
            <div class="sensor-data-list">
                    {sensorFields}
            </div>
          </div>
  </div>
`;
